import { Button, Card, Flex, Form } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProfileForm } from '../components'

export const ConfigProfilePage = () => {
  const { t } = useTranslation()
  const [profileForm] = Form.useForm()
  const [mfaForm] = Form.useForm()
  const [isPending, setIsPending] = useState(false)

  const onSubmit = () => {
    profileForm.submit()
    mfaForm.submit()
  }

  return (
    <Card
      actions={[
        <Flex justify="end" key={1}>
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            onClick={onSubmit}
          >
            {t('button.save')}
          </Button>
        </Flex>
      ]}
    >
      <ProfileForm form={profileForm} onPending={setIsPending} />
    </Card>
  )
}
